import { render, staticRenderFns } from "./IconSpeechBubble.vue?vue&type=template&id=4f352d3a&"
import script from "./IconSpeechBubble.vue?vue&type=script&lang=js&"
export * from "./IconSpeechBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports